import mInput from '@/components/lots/otpAdvance';
import paper from '@/components/core/paper/Paper';
import MSelect from '@/components/lots/otpSelect2';
import { dictWithUrl } from '@/components/otpPanel/api';
import bigDataLog from '@/utils/bigDataLog';
import templateDetailsDialog from './templateDetailsDialog.vue';
import Upload from '../../../components/upload/Index.vue';
import { uploadTemplate, uploadList, delFile } from '../../../../lsrm/api/bidScheme.js';
import { templateList, templateDetail, temptHeader, templateModify, temptFooterDel, temptFooterChange } from '../../../../lsrm/api/tenderTemp.js';
export default {
    name: 'templatedetails',
    components: { paper, MSelect, mInput, templateDetailsDialog, Upload },
    data() {
        return {
            loadHeadSave: false,
            loadDeaSave: false,
            showTemplateDialog: false, // 自定义弹窗
            tabRow: {},
            fieldTypeOptions: [], // 数字字典
            fieldAttributeOptions: [], // 数字字典
            suVisibleOptions: [], // 数字字典
            fieldNameOptions: [], // 数字字典
            dictData: {}, // 数字字典
            footerBtn: true,
            footDelId: [],
            files: {}, // 模板说明文件
            form: {
                templateCode: '',
                templateName: '',
                status: '3',
                calRuleName: '',
                templateDesc: '',
                businessType: '',
                lineType: '',
                calRuleCode: ''
            },
            formFoot: {
                tableData: [],
                footRules: {
                    fieldName: [{ required: true, message: ' ', trigger: 'change' }],
                    // fieldLineNo: [{ required: true, message: ' ', trigger: 'change', type: 'number' }],
                    fieldSeq: [{ required: true, message: ' ', type: 'number' }],
                    fieldType: [{ required: true, message: ' ', trigger: 'change' }],
                    fieldAttribute: [{ required: true, message: ' ', trigger: 'change' }],
                    suVisible: [{ required: true, message: ' ', trigger: 'change' }]
                }
            },
            rules: {
                templateName: [{ required: true, message: ' ', trigger: 'blur' }],
                businessType: [{ required: true, message: ' ', trigger: 'blur' }],
                lineType: [{ required: true, message: ' ', trigger: 'blur' }]
            },
            billingRuleTemplate: {
                value: 'ruleName',
                advanceConfig: [
                    { prop: 'ruleName', value: '计费规则名称' },
                    { prop: 'ruleCode', value: '计费规则编码' }
                ],
                advanceUrl: '/bid/getBidAccountRules',
                prefix: '/api-srm-web',
                name: '计费规则模板',
                tableConfig: [
                    { prop: 'ruleCode', value: '计费规则编码' },
                    { prop: 'ruleName', value: '计费规则名称' }
                ],
                cbParams: ['ruleName', 'ruleCode', 'remark', 'field']
            }
        };
    },
    mounted() {
        if (this.$route.query.mbpmFlowId) {
            this.$router.push({
                name: 'mipIframe',
                query: {
                    processId: this.$route.query.mbpmFlowId
                }
            });
        }
        bigDataLog.sendDetailMessageByKey('bigData-btn-page');
    },
    activated() {
        this.numDictionary(); // 数字字典
    },
    methods: {
        getFieldType(val, row) { this.$set(row, 'fieldType', val); },
        getFieldAttribute(val, row) { this.$set(row, 'fieldAttribute', val); },
        getSuVisible(val, row) { this.$set(row, 'suVisible', val); },
        async getFile() {
            const res = await uploadList({ moduleNo: this.form.templateCode });
            if (res && res.code === '0' && res.data) {
                this.files = res.data.list[0];
            }
        },
        async uploadSuccess(res) {
            const fileArr = res.data.data.localFileName.split('_');
            const type = res.data.data.downUrl.split('.').pop();
            const arr = [{
                moduleNo: this.form.templateCode,
                moduleType: 'bid_10',
                fileId: res.data.data.id,
                fileUrl: res.data.data.downUrl,
                fileName: fileArr[0] + '.' + type,
                fileType: res.data.data.downUrl.split('.')[res.data.data.downUrl.split('.').length - 1]
            }];
            const uploadRes = await uploadTemplate(arr, '');
            if (uploadRes && uploadRes.code === '0') {
                this.getFile();
                this.$message.success('上传成功');
            }
        },
        async delFileBtn() {
            const res = await delFile(this.files.id, '');
            if (res && res.code === '0') {
                this.$message.success('操作成功');
                this.files = {};
            }
        },
        downFile() {
            window.location = this.files.fileUrl;
        },
        getBusinessType(val) {
            this.form.businessType = val;
            if (val !== '3' && val !== '4' && val !== '5' && val !== '10') { this.form.lineType = ''; }
        },
        getRouteType(val) { this.form.lineType = val; },
        dialogDetermine(val) {
            const tabIndex = this.formFoot.tableData.indexOf(this.tabRow);
            this.formFoot.tableData[tabIndex].fieldName = val;
        },
        numDictionary() {
            dictWithUrl('BID_FIX_FIELD').then(res => {
                this.dictData = res.data;
                const keys = Object.keys(this.dictData.BID_FIX_FIELD);
                const fieldNameLatt = {};
                for (const key of keys.sort()) {
                    if (key !== '自定义') {
                        const obj = {};
                        obj.value = this.dictData.BID_FIX_FIELD[key];
                        obj.label = key;
                        this.fieldNameOptions.push(obj);
                    } else {
                        fieldNameLatt.value = this.dictData.BID_FIX_FIELD[key];
                        fieldNameLatt.label = key;
                    }
                }
                this.fieldNameOptions.push(fieldNameLatt);
                this.initHead();
            });
        },
        fieldNameChange(val, row) {
            this.tabRow = row;
            const tabIndex = this.formFoot.tableData.indexOf(this.tabRow);
            if (val === '自定义') {
                this.showTemplateDialog = true;
                this.formFoot.tableData[tabIndex].fieldAttribute = '1';
            } else {
                if (val === '单价' || val === '生效日期' || val === '失效日期') { row.fieldSeq = null; }
                if (this.form.lineType === '干线' || this.form.lineType === '支线') {
                    if (val === '起始地(区)' || val === '起始地编码(区)' || val === '起始地(镇)' || val === '起始地编码(镇)' || val === '目的地(镇)' || val === '目的地编码(镇)') {
                        this.$message.warning('线路类型为干/支线,不能选择此字段');
                        this.formFoot.tableData[tabIndex].fieldName = '';
                    }
                }
                this.formFoot.tableData[tabIndex].fieldAttribute = '2';
            }
        },
        dbClick(row, column, event) { // 双击列表
            if (!this.form.templateCode) { this.$message.warning('请先保存头部信息再操作模板'); return; }
            this.formFoot.tableData.forEach(item => {
                if (item.id && item.fieldName && item.fieldType && item.suVisible && item.fieldAttribute === '1' && item.fieldLineNo) {
                    item.edit = false;
                } else if (item.id && item.fieldName && item.fieldType && item.suVisible && item.fieldAttribute === '2') {
                    item.edit = false;
                } else { item.edit = true; }
            });
            row.edit = true;
        },
        compare(property) { // 对排序号进行排序
            return function(value1, value2) {
                const v1 = value1[property];
                const v2 = value2[property];
                return v1 - v2;
            };
        },
        async loadData(obj) { // 进入加载底部列表
            const res = await templateDetail(obj);
            if (res && res.code === '0') {
                this.formFoot.tableData = res.data.sort(this.compare('fieldSeq')) || [];
                const sortArray = this.formFoot.tableData.filter(item => !item.fieldSeq);
                this.formFoot.tableData = this.formFoot.tableData.filter(item => item.fieldSeq);
                this.formFoot.tableData.push(...sortArray);
                this.formFoot.tableData.forEach(item => {
                    this.$set(item, 'edit', false);
                    if (item.priceBarb) {
                        item.priceBarb = !(+item.priceBarb === 0);
                    }
                });
            }
        },
        getCalRule(val) {
            this.form.templateDesc = val.remark;
            this.form.calRuleName = val.ruleName;
            this.form.calRuleCode = val.ruleCode;
            this.formFoot.tableData = [];
            if (Array.isArray(val.field)) {
                val.field.forEach(item => {
                    this.$set(item, 'edit', true);
                    item.calRuleFieldName = item.fieldName;
                    delete item.fieldName;
                    this.formFoot.tableData.push(item);
                });
            }
        },
        backTemplate() { // 头部返回
            bigDataLog.sendDetailMessageByKey('bigData-btn-back');
            const listSave = this.formFoot.tableData.filter(item => { return !item.id; });
            if (listSave.length !== 0) {
                this.$confirm('当前模板明细还没保存，是否确认离去？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({ name: 'tendertemplate' });
                }).catch(() => {});
            } else {
                this.$router.push({ name: 'tendertemplate' });
            }
        },
        // 点击顶部保存
        async keepHeader() {
            if (this.form.templateCode) { // 新增后再点头部保存要获取id
                const res = await templateList({ templateCode: this.form.templateCode });
                this.form.id = res.data.list[0].id;
            }
            this.loadHeadSave = true;
            this.$refs['form'].validate(async valid => {
                if (valid) { // 修改
                    if (this.form.templateCode) {
                        const res = await templateModify(this.form.id, this.form);
                        this.loadHeadSave = false;
                        if (res && res.code === '0') {
                            this.$message.success('操作成功');
                        }
                    } else { // 新增
                        const res = await temptHeader(this.form);
                        this.loadHeadSave = false;
                        if (res && res.code === '0') {
                            this.form.templateCode = res.data;
                            this.footerBtn = true;
                            this.$message.success('操作成功');
                            this.formFoot.tableData.forEach(item => {
                                if (!item.id) { item.edit = true; }
                            });
                        }
                    }
                } else {
                    this.loadHeadSave = false;
                    this.$message.error('请输入完整的信息！');
                }
            });
        },
        // 判断是否有重复的字段序号
        isRepeat(arr, field) {
            var hash = {};
            for (var i in arr) {
                if (hash[arr[i][field]]) {
                    if (field === 'fieldSeq') {
                        this.$message.warning(`${arr[i][field] ? `排序号${arr[i][field]}不能重复` : '排序号不能为空'}`);
                    } else if (field === 'fieldName') {
                        this.$message.warning(`${arr[i][field] ? `字段名称${arr[i][field]}不能重复` : '字段名称不能为空'}`);
                    }
                    return true;
                } else {
                    hash[arr[i][field]] = true;
                }
            }
            return false;
        },
        // 点击底部保存
        keepFooter() {
            this.loadDeaSave = true;
            const arrFormFoot = this.formFoot.tableData.filter(item => {
                return item.fieldName !== '单价' && item.fieldName !== '生效日期' && item.fieldName !== '失效日期';
            });
            if (this.isRepeat(arrFormFoot, 'fieldSeq')) {
                this.loadDeaSave = false;
                return false;
            }
            if (this.isRepeat(this.formFoot.tableData, 'fieldName')) {
                this.loadDeaSave = false;
                return false;
            }
            const hasItem = this.formFoot.tableData.find(item => {
                return item.fieldName === '单价' && item.fieldAttribute === '2';
            });
            if (!hasItem) {
                this.$message.warning("请维护好固定列'单价'字段'");
                this.loadDeaSave = false;
                return;
            }
            let arrSeq = this.formFoot.tableData.filter(item => { return item.fieldSeq; });
            arrSeq = arrSeq.sort(this.compare('fieldSeq')) || [];
            if (arrSeq[0] && arrSeq[0].fieldAttribute !== '1') {
                this.$message.warning('排序号最前的一个字段必须为自定义字段');
                this.loadDeaSave = false;
                return;
            }
            this.$refs['footForms'].validate(async (valid, object) => {
                if (valid) {
                    this.formFoot.tableData = this.formFoot.tableData.sort(this.compare('fieldSeq')) || [];
                    this.formFoot.tableData.forEach(item => {
                        if (item.fieldAttribute === '1') {
                            item.fieldLineNo = item.fieldSeq;
                        } else { item.fieldLineNo = 'A'; }
                    });
                    let num = 0;
                    this.formFoot.tableData.forEach((item) => {
                        if (item.fieldAttribute === '1') {
                            num++;
                            item.fieldLineNo = num;
                        }
                        if (item.fieldLineNo === 'A') { item.fieldLineNo = ''; }
                    });

                    this.formFoot.tableData.forEach(el => {
                        el.templateCode = this.form.templateCode;
                    });
                    const tableData = JSON.parse(JSON.stringify(this.formFoot.tableData));
                    tableData.forEach(el => {
                        el.priceBarb = (el.priceBarb != null) ? (el.priceBarb ? 1 : 0) : null;
                    });
                    const res = await temptFooterChange(tableData);
                    this.loadDeaSave = false;
                    if (res && res.code === '0') {
                        this.$message.success('操作成功');
                        this.loadData({ templateCode: this.form.templateCode });
                    }
                } else {
                    this.loadDeaSave = false;
                    this.$message.error('请输入完整的信息！');
                }
            });
        },
        // 底部新增
        addTableData() {
            this.formFoot.tableData.push({ edit: true, fieldSeq: null, fieldLineNo: null });
        },
        // 底部删除
        deleteFooter() {
            if (this.footDelId.length === 0) {
                this.$message.warning('没有选中数据');
                return false;
            }
            const idArr = [];
            this.footDelId.forEach(el => {
                if (el.id) {
                    const obj = {};
                    obj.id = el.id;
                    idArr.push(obj);
                }
            });
            const hasCalRule = this.footDelId.filter(item => { return item.calRuleFieldName; });
            if (hasCalRule.length > 0) {
                this.$message.warning('无法删除计费规则模板带来的数据');
                return;
            }
            for (let i = 0; i < this.footDelId.length; i++) {
                for (let k = 0; k < this.formFoot.tableData.length; k++) {
                    if (this.footDelId[i] === this.formFoot.tableData[k] && !this.footDelId[i].id && !this.footDelId[i].calRuleFieldName) {
                        this.formFoot.tableData.splice(k, 1);
                    } else if (this.footDelId[i].id) {
                        this.$confirm('是否确定要删除选择的数据？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async() => {
                            const res = await temptFooterDel(idArr);
                            if (res && res.code === '0') {
                                this.$message.success('操作成功');
                                this.loadData({ templateCode: this.form.templateCode });
                            }
                        }).catch(() => {});
                    };
                }
            }
        },
        // 初始化
        async initHead() {
            if (this.$route.query.templateCode) { this.form.templateCode = this.$route.query.templateCode; }
            // 判断是新增进入还是修改进入
            if (this.$route.query.templateCode) {
                const res = await templateList({ templateCode: this.$route.query.templateCode });
                this.form = res.data.list[0];
                this.getFile();
                this.loadData({ templateCode: this.$route.query.templateCode });
                if (this.form.status !== '3' && this.form.status !== '4' && this.form.status !== '6') {
                    this.footerBtn = false;
                } else {
                    this.footerBtn = true;
                }
            } else {
                if (this.form.status === '3' && this.form.templateCode) {
                    this.footerBtn = true;
                } else {
                    this.footerBtn = false;
                }
            }
        },
        selectChange(val) { this.footDelId = val; },
        // 数字字典
        newAdded() { // 头部新增
            this.$router.push({ name: 'templatedetails' });
            this.initHead();
            this.form = {
                templateCode: '',
                templateName: '',
                status: '3',
                calRuleName: '',
                templateDesc: ''
            };
            this.files = {};
            this.footerBtn = false;
            this.formFoot.tableData = [];
        }
    }
};